import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';

const ContextMenu = ({ contextMenu, handleClose, onStockInfoClick }) => {
  return (
    <Menu
      id="basic-menu"
      anchorReference="anchorPosition"
      anchorPosition={
        Boolean(contextMenu.position)
          ? { top: contextMenu.position.mouseY, left: contextMenu.position.mouseX }
          : undefined
      }
      open={Boolean(contextMenu.position)}
      onClose={handleClose}
    >
      <MenuItem onClick={onStockInfoClick}>
        <ListItemIcon>
          <InventoryIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Készlet információ</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default ContextMenu;
